import { render, staticRenderFns } from "./BaixaEstoque.vue?vue&type=template&id=4c885c3a&scoped=true"
import script from "./BaixaEstoque.vue?vue&type=script&lang=js"
export * from "./BaixaEstoque.vue?vue&type=script&lang=js"
import style0 from "./BaixaEstoque.vue?vue&type=style&index=0&id=4c885c3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c885c3a",
  null
  
)

export default component.exports